module.exports = __webpack_public_path__ + "static/media/coming-soon.344ceb68.svg";